// Espelha matches/services/embed_catalog.py (dale-api-base), que e a fonte.
// Battle 2x5 saiu em 2026-08-04: nenhuma base de ligas jamais a teve.
export const LIVE_EMBED_COMPETITIONS = Object.freeze([
  { id: 'battle_2x4', label: 'Battle 2x4', entryMinute: 7, source: 'battle' },
  { id: 'volta_2x3', label: 'Volta', entryMinute: 5, source: 'volta' },
  { id: 'h2h_2x4', label: 'H2H 2x4', entryMinute: 7, source: 'facade' },
  { id: 'eadriatic_2x5', label: 'eAdriatic 2x5', entryMinute: 9, source: 'facade' },
  { id: 'gt_leagues_2x6', label: 'GT Leagues 2x6', entryMinute: 11, source: 'facade' },
  { id: 'epremier_2x6', label: 'ePremier 2x6', entryMinute: 11, source: 'facade' },
  { id: 'battle_2x6', label: 'Battle 2x6', entryMinute: 11, source: 'facade' },
  // So existe na Superbet; o dale-leagues a serve desde 2026-09-12 (#84).
  // entryMinute 8 = minuto do corte provisorio (8:46); o dashboard exige que bata com o checkpoint do catalogo.
  { id: 'cyber_live_arena_2x5', label: 'Cyber Live Arena 2x5', entryMinute: 8, source: 'facade' },
  // Jogo de 8 minutos (2x4); o dale-leagues a serve (dale-leagues#99). Corte no
  // minuto 7, mercado fecha de verdade aos 7:30. Sem canal shadow por enquanto.
  { id: 'valhalla_cup_2x4', label: 'Valhalla Cup 2x4', entryMinute: 7, source: 'facade' },
]);

/**
 * Canal shadow -> competicao. Espelha COMPETITION_TO_SHADOW do host
 * (dale-gather-wa, DaleLatestGamesRules.ts). Os chips do seletor mexem apenas em
 * `shadowChannels`, de proposito: mudar as competicoes do "Ao vivo" a partir
 * deles quebraria o espelhamento que o host faz ao reentrar na aba. Entao o
 * painel traduz aqui, em vez de exigir que o host funda os dois campos.
 */
const COMPETITION_BY_SHADOW_CHANNEL = Object.freeze({
  shadow: 'battle_2x4',
  'shadow-volta': 'volta_2x3',
  'shadow-h2h-2x4': 'h2h_2x4',
  'shadow-eadriatic-2x5': 'eadriatic_2x5',
  // Segunda lane da MESMA competicao: o Dale7 assina os jogos da eAdriatic com
  // outra estrategia. Nao e liga nova, e por isso divide o competition_id.
  'shadow-dale7-eadriatic': 'eadriatic_2x5',
  'shadow-gt-2x6': 'gt_leagues_2x6',
  'shadow-battle-2x6': 'battle_2x6',
});

/** Competicoes observadas pelos canais shadow marcados, na ordem do catalogo. */
export function competitionsForShadowChannels(channels) {
  if (!Array.isArray(channels) || channels.length === 0) return [];
  const selecionadas = new Set(
    channels.map((canal) => COMPETITION_BY_SHADOW_CHANNEL[canal]).filter(Boolean),
  );
  return LIVE_EMBED_COMPETITIONS
    .map((competition) => competition.id)
    .filter((id) => selecionadas.has(id));
}

/** Chip do Shadow -> lane de estrategia do contrato strategy_v1 da API. */
const STRATEGY_BY_SHADOW_CHANNEL = Object.freeze({
  'shadow-eadriatic-2x5': 'eadriatic_normal',
  'shadow-dale7-eadriatic': 'dale7_eadriatic',
});

/** Rotulo de cada lane no resumo. */
export const STRATEGY_LABELS = Object.freeze({
  eadriatic_normal: 'eAdriatic 2x5',
  dale7_eadriatic: 'Dale7 eAdriatic',
});

/**
 * As lanes que os chips marcados pedem, na ordem de exibicao.
 *
 * Nenhum chip marcado devolve as duas: o painel espelha o host, e o host sem
 * selecao nenhuma mostra tudo. Esconder as duas deixaria o topo vazio com a
 * lista logo abaixo cheia.
 */
export function eadriaticLanesForShadowChannels(channels) {
  const marcados = Array.isArray(channels) ? channels : [];
  const lanes = ['eadriatic_normal', 'dale7_eadriatic']
    .filter((lane) => marcados.some((canal) => STRATEGY_BY_SHADOW_CHANNEL[canal] === lane));
  return lanes.length > 0 ? lanes : ['eadriatic_normal', 'dale7_eadriatic'];
}

const COMPETITIONS_BY_ID = new Map(LIVE_EMBED_COMPETITIONS.map((competition) => [competition.id, competition]));
// 'shadow' is host-side only (this embed renders no shadow UI), but the
// profile round-trips it: rejecting it here threw the whole preferences
// object away and locked the embed into a "Preferencias indisponiveis"
// retry loop as soon as the user saved while on the Shadow tab.
const GAME_TYPES = new Set(['call', 'duplinha', 'shadow']);

export const DEFAULT_LIVE_EMBED_PREFERENCES = Object.freeze({
  version: 1,
  competitionIds: Object.freeze(['battle_2x4']),
  gameTypes: Object.freeze([]),
  hideSkips: false,
  hideGoal67: false,
  tiedAtEntryOnly: false,
});

export function sanitizeLiveEmbedPreferences(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || value.version !== 1) return null;
  const competitionIds = value.competitionIds;
  const gameTypes = value.gameTypes;
  if (
    !Array.isArray(competitionIds)
    || competitionIds.length === 0
    || competitionIds.length > LIVE_EMBED_COMPETITIONS.length
    || competitionIds.some((id) => typeof id !== 'string' || !COMPETITIONS_BY_ID.has(id))
    || new Set(competitionIds).size !== competitionIds.length
    || !Array.isArray(gameTypes)
    || gameTypes.some((type) => !GAME_TYPES.has(type))
    || new Set(gameTypes).size !== gameTypes.length
    || typeof value.hideSkips !== 'boolean'
    || typeof value.hideGoal67 !== 'boolean'
    || typeof value.tiedAtEntryOnly !== 'boolean'
  ) return null;
  const sanitized = {
    version: 1,
    competitionIds: [...competitionIds],
    gameTypes: [...gameTypes],
    hideSkips: value.hideSkips,
    hideGoal67: value.hideGoal67,
    tiedAtEntryOnly: value.tiedAtEntryOnly,
  };
  // Opaque passthrough: this embed does not use shadowChannels, but dropping it
  // amputated the object we echo back (and PATCH into the profile), which reset
  // the host's shadow channel selection to its default.
  if (
    Array.isArray(value.shadowChannels)
    && value.shadowChannels.every((channel) => typeof channel === 'string')
  ) {
    sanitized.shadowChannels = [...value.shadowChannels];
  }
  return sanitized;
}
export function toggleCompetition(selectedIds, competitionId) {
  if (!COMPETITIONS_BY_ID.has(competitionId)) return [...selectedIds];
  if (!selectedIds.includes(competitionId)) return [...selectedIds, competitionId];
  if (selectedIds.length === 1) return [...selectedIds];
  return selectedIds.filter((id) => id !== competitionId);
}

export function competitionSelectionLabel(selectedIds) {
  const valid = selectedIds.filter((id) => COMPETITIONS_BY_ID.has(id));
  const first = COMPETITIONS_BY_ID.get(valid[0]) || LIVE_EMBED_COMPETITIONS[0];
  return valid.length > 1 ? `${first.label} +${valid.length - 1}` : first.label;
}

export function competitionBadge(id) {
  const competition = COMPETITIONS_BY_ID.get(id);
  if (!competition) return null;
  return {
    label: competition.label,
    className: id === 'volta_2x3' ? 'match__badge--volta' : 'match__badge--competition',
  };
}

export function competitionContextClass(id) {
  if (!COMPETITIONS_BY_ID.has(id)) return null;
  return `match--league-${id.replaceAll('_', '-')}`;
}

export function filterRankingGroupByCompetitions(group, selectedIds) {
  const selected = new Set(
    (selectedIds || []).filter((id) => COMPETITIONS_BY_ID.has(id)),
  );
  const filterRows = (rows) => (rows || []).filter((row) => selected.has(row?.competitionId));
  return {
    best: filterRows(group?.best),
    worst: filterRows(group?.worst),
  };
}

export function shouldCloseCompetitionMenu(root, nextTarget) {
  return !!root && (!nextTarget || !root.contains(nextTarget));
}

export function selectedNewCompetitionIds(selectedIds) {
  return selectedIds.filter((id) => COMPETITIONS_BY_ID.get(id)?.source === 'facade');
}

/**
 * Competicoes cujas PARTIDAS tem fonte legada propria e nao devem vir do facade.
 *
 * O card legado do Battle carrega historico, timeline de gols e badges de bot
 * que a versao do dashboard nao traz. Como `mergeScopedMatches` deixa o facade
 * sobrescrever o legado pela mesma chave, uma partida de battle_2x4 vinda do
 * dashboard apagava o card rico da tela. Pedimos essa competicao ao dashboard
 * apenas pelas ENTRADAS de shadow — as partidas continuam sendo do stream ao
 * vivo de sempre.
 */
const LANES_COM_FONTE_LEGADA = new Set(['battle_2x4', 'volta_2x3']);

export function semLaneLegada(matches) {
  return (matches || []).filter((match) => !LANES_COM_FONTE_LEGADA.has(match?.competitionId));
}

/**
 * Competicoes que o feed de entradas do dashboard serve.
 *
 * `battle_2x4` tem source 'battle' e por isso ficava de fora do pedido — regra
 * que valia quando aquela competicao so existia como Dale normal, vindo do
 * balde diario. O Battle shadow mudou isso: ele chega pelo feed com
 * `competition_id = battle_2x4`, entao nao pedir a competicao deixava o painel
 * sem nenhuma entrada de shadow do Battle, enquanto a lista do play — que pede
 * sem esse filtro — mostrava o card. Contador e lista discordavam na tela.
 *
 * O source segue 'battle': quem manda no balde legado e em
 * `legacySourceTransition` nao muda.
 */
export function dashboardCompetitionIds(selectedIds) {
  return selectedIds.filter((id) => COMPETITIONS_BY_ID.has(id));
}

export function legacySourceTransition(previousIds, nextIds) {
  const previous = new Set(previousIds);
  const next = new Set(nextIds);
  return {
    openBattle: !previous.has('battle_2x4') && next.has('battle_2x4'),
    closeBattle: previous.has('battle_2x4') && !next.has('battle_2x4'),
    openVolta: !previous.has('volta_2x3') && next.has('volta_2x3'),
    closeVolta: previous.has('volta_2x3') && !next.has('volta_2x3'),
  };
}
